import $ from 'jquery';
import _ from 'lodash';
import { api } from '../common/api';
import { drawing } from '../common/drawing';
import { parts } from '../common/parts';
import { util } from '../common/util';
import { ui } from '../common/ui';

import { client } from './client_v2';
import { userinfo } from '../common/userinfo';
import { messageUtility } from '../../utilities/messageUtility';
import { isIPad } from '../../utilities/commonUtil';

function _places() {
  this._selectId = '';
  this._selectName = '';
  this._scale = '';
  this._placeList = '';
  this._copyPlaceId = '';
  // 初期化
  this.init = async function(placeId) {
    var self = this;
    $('[name="place_id"]').val(placeId);
    self._selectId = placeId;

    const res = await api.getPlace();
    var placeList = res.data.entities.construction_placement_places;
    self._placeList = placeList;
    self.setSelectPlace(placeList);
    self.setSplitViewSelectPlace(placeList);
    self.setCopySelectPlace(placeList);
    self.reload();

    // 画面単独表示時(非分割時) 場所選択 プルダウンメニュー
    $('[name="place_name"]').click(function() {
      $('.select-place .dropdown .dropdown-single-select__scroll').show();
      $('.select-place .dropdown').addClass('show');
      $(`#construction-radio${self._selectId}`).prop('checked', true);
    });
    $(document).click(function(e) {
      if ($('.select-place .dropdown').hasClass('show')) {
        if (!$(e.target).closest('.select-place').length) {
          $('.select-place .dropdown').removeClass('show');
          if (isIPad()) {
            $('.select-place .dropdown .dropdown-single-select__scroll').hide();
          }
        }
      }
    });

    // 画面単独表示時(非分割時) 場所選択 プルダウンメニュー 場所名を入力して検索 入力
    $('[name=search_place]').change(function() {
      let word = $(this).val();
      let hasData = false;
      let hasNodataMessage = $('.place-list .table-has-no-data');
      _.each($('.select-place .dropdown .place_item'), function(item) {
        let name = $(item).attr('data-name');
        if (name.indexOf(word) >= 0 || word === '') {
          hasData = true;
          $(item).show();
        } else {
          $(item).hide();
        }
      });
      hasData ? hasNodataMessage.hide() : hasNodataMessage.show();
    });

    // 画面単独表示時(非分割時) 場所変更 プルダウンメニュー 変更 ボタン

    $(document).on('click', () => {
      $('.sys-change-place')
        .off('click')
        .click(async function() {
          const selectId = $(this)
            .children('[name="select_place"]')
            .val();
          const currentId = $('[name="place_id"]').val();
          const dropDownPlace = $('.select-place .dropdown');
          if (selectId === undefined || selectId === currentId) {
            dropDownPlace.removeClass('show');
            return;
          }

          drawing.hidePrintFrame();
          self._selectId = selectId;
          places.reload();

          await places.reloadScaleWhenChangePlace();
          self.setSplitViewSelectPlace(placeList);
          self.setCopySelectPlace(placeList);
          dropDownPlace.removeClass('show');
        });

      // コピー元を選択 ダイアログ 場所 プルダウンメニュー 変更 ボタン
      $('#modal-dialog-copy-select .sys-change-copy-place')
        .off('click')
        .click(function() {
          places._copyPlaceId = $(this)
            .children('[name="select_copy_place"]')
            .val();
          const name = $(this)
            .children('[name="select_copy_place"]')
            .closest('li')
            .find('.select-copy-place-name')
            .text();
          $('#modal-dialog-copy-select [name=copy_place_id]').val(
            places._copyPlaceId
          );
          $('#modal-dialog-copy-select [name=copy_place_name]').val(name);
          $('#modal-dialog-copy-select .copy_place_name_label').text(name);
          $('.select-copy-place .dropdown').removeClass('show');
        });

      // 画面分割時 場所変更 プルダウンメニュー 変更 ボタン
      $('.sys-change-split-view-place')
        .off('click')
        .click(function() {
          const splitView = $(this).closest('.layout-canvas');
          const placeId = $(this)
            .children('[name=select_place]')
            .val();
          const name = $(this)
            .children('[name=select_place]')
            .closest('li')
            .find('.select-place-name')
            .text();
          $(splitView)
            .find('[name=split_view_place_id]')
            .val(placeId);
          $(splitView)
            .find('[name=split_view_place]')
            .val(name);
          ui.updateSplitView(splitView);
          $('.split-view-select-place .dropdown').removeClass('show');
          $('.layout-tool-footer').show();
        });
    });

    // 画面単独表示時(非分割時) 場所選択 上ボタン
    $('.sys-place-down i').click(function() {
      let tmpPlace = '';
      _.each(self._placeList, function(place) {
        if (place.id === self._selectId && tmpPlace !== '') {
          drawing.hidePrintFrame();
          self._selectId = tmpPlace.id;
          self._selectName = tmpPlace.name;
          places.reload();

          // split.reload();
          // 単独選択時には split の更新は必要ないのでコメントアウトした
          places.reloadScaleWhenChangePlace();
          return false;
        }
        tmpPlace = place;
      });
    });

    // 画面単独表示時(非分割時) 場所選択 下ボタン
    $('.sys-place-up i').click(function() {
      let flag = false;
      _.each(self._placeList, function(place) {
        if (flag) {
          drawing.hidePrintFrame();
          self._selectId = place.id;
          self._selectName = place.name;
          places.reload();

          // split.reload();
          // 単独選択時には split の更新は必要ないのでコメントアウトした
          places.reloadScaleWhenChangePlace();
          return false;
        }
        if (place.id === self._selectId) {
          flag = true;
        }
      });
    });
  };

  this.getPlaceId = function() {
    return this._selectId;
  };

  this.getPlaceName = function() {
    return this._selectName;
  };

  // 場所選択 処理
  this.setSelectPlace = function(placeList) {
    var self = this;

    var beforeId = $('[name="place_id"]').val();
    var beforeName = '';
    var beforeScale = 0;
    var placeSelectList = _.map(placeList, function(place) {
      if (beforeId === '' || beforeId == place.id) {
        beforeId = place.id;
        beforeName = place.name;
        beforeScale = place.scale;
      }
      return (
        `${'' + '<li class="single-select__item place_item" data-name="'}${
          place.name
        }">` +
        `<label class="radio sys-change-place" for="construction-radio${
          place.id
        }">` +
        `<input id="construction-radio${place.id}" value="${
          place.id
        }" type="radio" name="select_place">` +
        `<svg viewBox="0 0 24 24" class="icon--1_6x">` +
        `<path d="M0 0h24v24H0V0z" fill="none"></path>` +
        `<circle cx="12" cy="12" r="9" fill="#fff"></circle>` +
        `<path d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm0 18c-4.4 0-8-3.6-8-8s3.6-8 8-8 8 3.6 8 8-3.6 8-8 8z"></path>` +
        `<circle cx="12" cy="12" r="5"></circle>` +
        `</svg>` +
        `<span class="single-select__label-text">${_.escape(
          place.name
        )}</span>` +
        `</label>` +
        `</li>`
      );
    });
    $('.select-place .place-list').html('');
    $('.select-place .place-list')
      .append(placeSelectList)
      .append(
        `<div class='table-has-no-data'>
            <div class='table-has-no-data__message'>
             ${messageUtility.getMessage('I-000-046')}
            </div>
           </div>`
      );
    if (beforeId != '' && beforeName != '') {
      self._selectId = beforeId;
      self._selectName = beforeName;
      self._scale = beforeScale;
      parts.updatePartsScale(beforeScale);
      $('[name="place_id"]').val(beforeId);
      $('[name="place_name"]').val(beforeName);
    }
  };

  // 画面分割時 場所選択 処理
  this.setSplitViewSelectPlace = function(placeList) {
    _.each($('.split-canvas'), function(view) {
      var placeSelectList = _.map(placeList, function(place) {
        return (
          `${'' + '<li class="single-select__item place_item" data-name="'}${
            place.name
          }">` +
          `<label class="radio sys-change-split-view-place" for="construction-radio${$(
            view
          ).attr('data-splitno')}-${place.id}">` +
          `<input id="construction-radio${$(view).attr('data-splitno')}-${
            place.id
          }" value="${place.id}" type="radio" name="select_place">` +
          `<svg viewBox="0 0 24 24" class="icon--1_6x">` +
          `<path d="M0 0h24v24H0V0z" fill="none"></path>` +
          `<circle cx="12" cy="12" r="9" fill="#fff"></circle>` +
          `<path d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm0 18c-4.4 0-8-3.6-8-8s3.6-8 8-8 8 3.6 8 8-3.6 8-8 8z"></path>` +
          `<circle cx="12" cy="12" r="5"></circle>` +
          `</svg>` +
          `<span class="single-select__label-text select-place-name">${_.escape(
            place.name
          )}</span>` +
          `</label>` +
          `<label for="construction-radio${$(view).attr('data-splitno')}-${
            place.id
          }">` +
          `</label>` +
          `</li>`
        );
      });
      $(view)
        .find('.split-view-place-list')
        .html('');
      $(view)
        .find('.split-view-place-list')
        .append(placeSelectList)
        .append(
          `<div class='table-has-no-data'>
            <div class='table-has-no-data__message'>
             ${messageUtility.getMessage('I-000-046')}
            </div>
           </div>`
        );
    });
  };

  // コピー元を選択 ダイアログ 場所選択 内容指定
  this.setCopySelectPlace = function(placeList) {
    var placeSelectList = _.map(placeList, function(place) {
      return (
        `${'' +
          '<li class="single-select__item ">' +
          '<label class="radio sys-change-copy-place" for="construction-radio-copy-'}${
          place.id
        }">` +
        `<input id="construction-radio-copy-${place.id}" value="${
          place.id
        }" type="radio" name="select_copy_place">` +
        `<svg viewBox="0 0 24 24" class="icon--1_6x">` +
        `<path d="M0 0h24v24H0V0z" fill="none"></path>` +
        `<circle cx="12" cy="12" r="9" fill="#fff"></circle>` +
        `<path d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm0 18c-4.4 0-8-3.6-8-8s3.6-8 8-8 8 3.6 8 8-3.6 8-8 8z"></path>` +
        `<circle cx="12" cy="12" r="5"></circle>` +
        `</svg>` +
        `<span class="single-select__label-text select-copy-place-name">${_.escape(
          place.name
        )}</span>` +
        `</label>` +
        `</li>`
      );
    });
    $('.copy-place-list').html('');
    $('.copy-place-list').append(placeSelectList);
  };

  // 場所更新
  this.reload = function(dt) {
    // console.log('debug', 'places.js reload');

    var self = this;

    if (dt == undefined) {
      dt = ui.currentDate;
    }
    var id = self._selectId;
    $('[name="place_id"]').val(id);
    $('[name="place_name"]').val(self._selectName);

    client.changeRoom(util.getRoomId(id, dt), id);
  };

  this.changeScale = function() {
    let self = this;
    let placeId = places.getPlaceId();
    let place = {
      scale: self._scale,
      field_id: userinfo.getFieldId(),
      company_branch_id: userinfo.getCompanyBranchId(),
    };
    api.updatePlace(placeId, place);
  };

  this.reloadScaleWhenChangePlace = async function() {
    let self = this;
    const res = await api.getPlace();
    const placeList = res.data.entities.construction_placement_places;
    self._placeList = placeList;
    self.setSelectPlace(placeList);
  };
  // preventDefault click on li.place_item
  this.bindPlaceItemClick = function() {
    const placeItems = $(
      'li.place_item , .select-copy-place li.single-select__item'
    );
    placeItems.off('click.place_item');
    placeItems.on('click.place_item', function() {
      $(this)
        .find('input[type=radio]')
        .prop('checked', true);
      return false;
    });
  };
}

export const places = new _places();



// WEBPACK FOOTER //
// ./src/canvas/constructionPlacement/places.js